export default "__VITE_ASSET__CtsvZLYU__"